import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
export const ClaraLoginReviewContainer = styled(Box)(({theme}) => ({
  margin: "30px 0 10px 40px",
  position: 'relative',
  zIndex: 1,
  heigth:'100vh',
  overflow: 'hidden',
  [theme.breakpoints.down(1370)]: {
    margin: "25px 0 25px 40px",
  },
  [theme.breakpoints.down(1025)]: {
    display: 'none'
  }
}));
export const ClaraLoginReviewImage = styled(Box)(() => ({
  display: "flex",
  position: 'relative',
  zIndex:5,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}));
export const HomepageTypography = styled(Typography)(({ theme }) => ({
    ".em": {
        color: theme.palette.primary.main,
    },
    color: theme.palette.claraPalette.darkGray,
  lineHeight: "28.4px",
}));
